import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["inputProps", "inputRef", "className", "disabled"];
import React from 'react';
import { CoreInput } from "./CoreInput";
var TextArea = function TextArea(_ref) {
  var inputProps = _ref.inputProps,
    inputRef = _ref.inputRef,
    className = _ref.className,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CoreInput, _extends({}, props, {
    disabled: disabled,
    "data-t-id": "Input-components"
  }), /*#__PURE__*/React.createElement("textarea", _extends({}, inputProps, {
    className: className,
    disabled: disabled,
    ref: inputRef,
    "data-t-id": "Input-components"
  })));
};
export { TextArea };